// modules
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import { addModal } from 'weblite-web-modal-viewer'
// component
import { ContactDialog } from './contact-dialog'

const COMPONENT_ID = 'contactDialog'

export const showContactDialog = () => addModal({ id: COMPONENT_ID })

export default {
  [COMPONENT_ID]: {
    Component: ContactDialog,
  },
}
